export default class SubscriptionDropdown {
  constructor(options, callback) {
    if (options?.el) {
      this.init(options, callback);
    }
  }

  init(options, callback) {
    this.dropdown =
      typeof options.el === "string"
        ? document.querySelector(options.el)
        : options.el;
    this.callback = callback;
    this.currentSellingPlanId = this.dropdown.value;
    this.product = window.Solawave_Store.current_product || options.buyBoxProduct;
    this.variant = window.Solawave_Store.current_variant || options.buyBoxVariant;
    this.variantGroupBlacklist = options.variantGroupBlacklist
      ? options.variantGroupBlacklist
      : [];

    this.dropdown.addEventListener("change", (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      selectedOption.setAttribute("selected", "selected");
      [...e.target.options].forEach((option) => {
        if (option !== selectedOption) {
          option.removeAttribute("selected");
        }
      });

      this.currentSellingPlanId = e.target.value;

      this.callback({
        target: e.target,
        selling_plan_id: this.currentSellingPlanId,
      });
    });

    window.MicroBus.on('variant:change', ({ detail }) => {
      const { variant, location } = detail
      if (location !== 'buybox') return
      this.variant = variant
      this.updateSelectOptions(this.product, this.variant)
    })

    // ensuring the dropdown is updated on init
    this.updateSelectOptions(this.product, this.variant);
  }

  updateSelectOptions = (product, variant) => {
    this.dropdown.innerHTML = "";
    
    //Add selling plans to dropdown based on variant
    variant.selling_plan_allocations.forEach((allocation, i) => {
      const option = document.createElement("option");
      const currentProductSellingPlanGroup = product.selling_plan_groups.find(
        (group) => group.id === allocation.selling_plan_group_id
      );
      if (
        this.variantGroupBlacklist.find(
          (group) =>
            group.variantId == variant.id &&
            group.hideSellingGroup.includes(allocation.selling_plan_group_id)
        )
      ) {
        return;
      }
      const currentVariantSellingPlanGroups =
        currentProductSellingPlanGroup.selling_plans.find(
          (plan) => plan.id === allocation.selling_plan_id
        );
      option.value = allocation.selling_plan_id;
      option.text = currentVariantSellingPlanGroups.name;

      if (i === 0) {
        option.setAttribute("selected", "selected");
        this.dropdown.value = option.value;
      } else {
        option.removeAttribute("selected");
      }
      this.dropdown.appendChild(option);
    });
  };
}
